/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewticketearnings2Inputs */

const en_overviewticketearnings2 = /** @type {(inputs: Overviewticketearnings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket earnings`)
};

const de_overviewticketearnings2 = /** @type {(inputs: Overviewticketearnings2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketeinnahmen`)
};

/**
* | output |
* | --- |
* | "Ticket earnings" |
*
* @param {Overviewticketearnings2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewticketearnings2 = /** @type {((inputs?: Overviewticketearnings2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewticketearnings2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewticketearnings2(inputs)
	return de_overviewticketearnings2(inputs)
});
export { overviewticketearnings2 as "overviewTicketEarnings" }